import type { Theme, SxProps } from "@mui/material/styles";

export const newChargePanelStyles = (
  theme: Theme,
): Record<string, SxProps<Theme>> => ({
  formContainer: {
    padding: theme.spacing(3),
  },
  buttonsContainer: {
    display: "flex",
    justifyContent: "center",
    marginTop: theme.spacing(4),
    gap: theme.spacing(2),
  },
  title: {
    fontWeight: 600,
    marginBottom: theme.spacing(3),
    fontSize: "2rem",
    textAlign: "center",
  },
  heatInput: {
    backgroundColor: "white",
    "& .MuiOutlinedInput-root": {
      backgroundColor: "white",
      "& .MuiOutlinedInput-input": {
        color: theme.palette.text.primary,
        fontWeight: 600,
      },
    },
  },
  actionButton: {
    padding: theme.spacing(1.5, 3),
    minWidth: "180px",
    fontSize: "1.2rem",
    fontWeight: 600,
    borderRadius: "8px",
    minHeight: "56px",
    textTransform: "none",
    boxShadow: "0 3px 5px rgba(0,0,0,0.2)",
  },
  bucketButton: {
    minWidth: "102px",
    fontSize: "1.8rem",
    fontWeight: 600,
    borderRadius: "8px",
    minHeight: "102px",
    textTransform: "none",
    boxShadow: "0 3px 5px rgba(0,0,0,0.2)",
  },
  cancelButton: {
    padding: theme.spacing(1.5, 3),
    minWidth: "180px",
    fontSize: "1.2rem",
    fontWeight: 600,
    borderRadius: "8px",
    minHeight: "56px",
    textTransform: "none",
    boxShadow: "0 3px 5px rgba(0,0,0,0.2)",
    backgroundColor: theme.palette.charges.backgrounds.light,
    color: theme.palette.text.primary,
  },
  scheduleButton: {
    padding: theme.spacing(1.5, 3),
    minWidth: "180px",
    fontSize: "1.2rem",
    fontWeight: 600,
    borderRadius: "8px",
    minHeight: "56px",
    textTransform: "none",
    boxShadow: "0 3px 5px rgba(0,0,0,0.2)",
    backgroundColor: theme.palette.info.main,
    color: "white",
    "&.Mui-disabled": {
      backgroundColor: theme.palette.charges.borders.medium,
      color: theme.palette.charges.status.inactive,
    },
  },
  startButton: {
    padding: theme.spacing(1.5, 3),
    minWidth: "180px",
    fontSize: "1.2rem",
    fontWeight: 600,
    borderRadius: "8px",
    minHeight: "56px",
    textTransform: "none",
    boxShadow: "0 3px 5px rgba(0,0,0,0.2)",
    backgroundColor: theme.palette.charges.status.active,
    color: "white",
    "&.Mui-disabled": {
      backgroundColor: theme.palette.charges.borders.medium,
      color: theme.palette.charges.status.inactive,
    },
  },
});
